var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19 19-6-6zm-4-11c0 .91925-.1811 1.82951-.5328 2.6788-.3518.8493-.8674 1.6209-1.5175 2.2709-.65.6501-1.4216 1.1657-2.2709 1.5175-.84929.3517-1.75955.5328-2.6788.5328s-1.8295-.1811-2.67878-.5328c-.84928-.3518-1.62096-.8674-2.27097-1.5175-.65001-.65-1.16562-1.4216-1.51741-2.2709-.35178-.84929-.53284-1.75955-.53284-2.6788 0-1.85652.7375-3.63699 2.05025-4.94975 1.31276-1.31275 3.09323-2.05025 4.94975-2.05025s3.637.7375 4.9497 2.05025c1.3128 1.31276 2.0503 3.09323 2.0503 4.94975z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9e19df5814e0aa740808e54c688886a1.svg";
export { ForwardRef as ReactComponent };